'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UserMenu = undefined;

var _themeProvider = require('@spp/theme-provider');

var _UserMenu = require('./UserMenu');

var _UserMenu2 = _interopRequireDefault(_UserMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.UserMenu = _UserMenu2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-user-menu')(_UserMenu2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/UserMenu/index.js
 ** module id = 621
 ** module chunks = 1
 **/